import { format, isValid, parse, parseISO } from "date-fns";

const OPERATOR_ROLE_ID = 5;

// Отчёт содержит данные чужих организаций — доступен только оператору (Администратор ЦРЦЭ)
export const canAccessParticipantsRegistry = (userData: any) =>
  Array.isArray(userData?.selectRoleV2) &&
  userData.selectRoleV2.some(
    (role: { roleId: number }) => role.roleId === OPERATOR_ROLE_ID,
  );

export const getReportStatusMeta = (
  status: string,
  t: (key: string) => string,
) => {
  switch (status) {
    case "FORMING":
      return { type: "test", label: t("marking_codes_report.status_forming") };
    case "FORMED":
      return { type: "active", label: t("marking_codes_report.status_formed") };
    case "ERROR":
      return { type: "error", label: t("marking_codes_report.status_error") };
    default:
      return { type: "", label: status || "-" };
  }
};

export const formatDisplayDateTime = (value?: string) => {
  if (!value) return "-";
  const parsed = parseISO(value);
  if (!isValid(parsed)) return value;
  return format(parsed, "dd.MM.yyyy HH:mm");
};

// ДД.ММ.ГГГГ из календаря → yyyy-MM-dd для API
export const toApiDate = (value: string) => {
  if (!value) return undefined;
  const parsed = parse(value, "dd.MM.yyyy", new Date());
  if (!isValid(parsed)) return undefined;
  return format(parsed, "yyyy-MM-dd");
};

export const parseFormDate = (value: string) => {
  if (!value) return null;
  const parsed = parse(value, "dd.MM.yyyy", new Date());
  return isValid(parsed) ? parsed : null;
};

export const getReportDate = (report: {
  completedAt?: string;
  requestedAt?: string;
  startedAt?: string;
}) => report.completedAt || report.requestedAt || report.startedAt;
